/* ========================================
   BK-MEDIA CUSTOM JAVASCRIPT
   ======================================== */

/* ========================================
   FREE SHIPPING BAR DISCOUNT FIX
   ======================================== */

(function() {
  'use strict';

  function calculateDiscountedTotal(cart) {
    const items = cart["items"] || [];
    const discountApplications = cart["cart_level_discount_applications"] || [];
    
    // Calculate total price for items that require shipping
    // Use final_line_price which already includes line-level discounts
    let priceForItems = 0;
    for (const item of items) {
      if (item["requires_shipping"] === true) {
        const linePrice = parseFloat(item["final_line_price"]);
        if (!isNaN(linePrice) && linePrice > 0) {
          priceForItems += linePrice;
        }
      }
    }
    
    // Calculate total cart-level discounts
    let cartDiscount = 0;
    for (const discount of discountApplications) {
      const discountAmount = parseFloat(discount["total_allocated_amount"]);
      if (!isNaN(discountAmount) && discountAmount > 0) {
        cartDiscount += discountAmount;
      }
    }
    
    // Calculate final total (items total minus cart-level discounts)
    const calculatedTotal = priceForItems - cartDiscount;
    
    // Ensure we have a valid number (at least 0)
    return isNaN(calculatedTotal) || calculatedTotal < 0 ? 0 : calculatedTotal;
  }

  function updateFreeShippingBars(cart) {
    const freeShippingBars = document.querySelectorAll('free-shipping-bar');
    const discountedTotal = calculateDiscountedTotal(cart);
    
    freeShippingBars.forEach(bar => {
      // Update the total-price attribute, which will trigger attributeChangedCallback
      const currentTotal = parseFloat(bar.getAttribute('total-price'));
      if (isNaN(currentTotal) || currentTotal !== discountedTotal) {
        bar.setAttribute('total-price', discountedTotal);
      }
    });
  }

  // Listen for cart:change events and update free shipping bars
  document.addEventListener('cart:change', function(event) {
    const cart = event.detail && event.detail["cart"];
    if (cart) {
      updateFreeShippingBars(cart);
    }
  });

  // Initialize on page load
  function init() {
    // Wait a bit for custom elements to be defined
    setTimeout(function() {
      const freeShippingBars = document.querySelectorAll('free-shipping-bar');
      if (freeShippingBars.length > 0) {
        // Enhance the _onCartChanged method on the prototype
        const FreeShippingBarElement = window.customElements.get('free-shipping-bar');
        if (FreeShippingBarElement && FreeShippingBarElement.prototype) {
          const originalOnCartChanged = FreeShippingBarElement.prototype._onCartChanged;
          
          if (originalOnCartChanged) {
            FreeShippingBarElement.prototype._onCartChanged = function(event) {
              const cart = event.detail["cart"] || {};
              const discountedTotal = calculateDiscountedTotal(cart);
              this.totalPrice = discountedTotal;
            };
          }
        }
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ========================================
   BLOG FILTER SYSTEM
   ======================================== */

(function() {
  'use strict';

  function initBlogFilters() {
    const filterDataScript = document.querySelector('[data-blog-filter-data]');
    if (!filterDataScript) return;

    let filterData = {};
    try {
      filterData = JSON.parse(filterDataScript.textContent);
    } catch (e) {
      console.error('Failed to parse blog filter data:', e);
      return;
    }

    const filterForm = document.querySelector('[data-blog-filter-form]');
    const postsContainer = document.querySelector('[data-blog-posts-container]');
    const activeFiltersContainer = document.querySelector('[data-blog-active-filters]');
    
    if (!filterForm || !postsContainer) return;

    let calculatedMinTime = Infinity;
    let calculatedMaxTime = 0;
    
    if (filterData.articles && filterData.articles.length > 0) {
      filterData.articles.forEach(article => {
        const gesamtzeit = article.gesamtzeit || 0;
        if (gesamtzeit < calculatedMinTime) {
          calculatedMinTime = gesamtzeit;
        }
        if (gesamtzeit > calculatedMaxTime) {
          calculatedMaxTime = gesamtzeit;
        }
      });
    }
    
    if (calculatedMinTime === Infinity) calculatedMinTime = 0;
    if (calculatedMaxTime === 0 && calculatedMinTime > 0) calculatedMaxTime = calculatedMinTime;
    
    filterData.minTime = calculatedMinTime;
    filterData.maxTime = 300;

    let currentFilters = {
      kategorie: [],
      schwierigkeit: [],
      timeMin: filterData.minTime || 0,
      timeMax: 300,
      currentPage: 1
    };
    
    const articlesPerPage = filterData.articlesPerPage || 12;
    const paginationContainer = document.querySelector('[data-blog-pagination]');
    
    const timeMinInputs = document.querySelectorAll('[data-time-min]');
    const timeMaxInputs = document.querySelectorAll('[data-time-max]');
    const timeRangeInputs = document.querySelectorAll('[data-time-range]');
    
    timeMinInputs.forEach(input => {
      input.max = 300;
      input.min = filterData.minTime;
    });
    timeMaxInputs.forEach(input => {
      input.max = 300;
      input.min = filterData.minTime;
    });
    timeRangeInputs.forEach(input => {
      input.max = 300;
      input.min = filterData.minTime;
      input.value = 300;
    });

    function getArticleElement(articleId) {
      return postsContainer.querySelector(`[data-article-id="${articleId}"]`);
    }

    function matchesFilters(articleElement) {
      const articleId = articleElement.getAttribute('data-article-id');
      const article = filterData.articles.find(a => String(a.id) === articleId);
      if (!article) return false;

      if (currentFilters.kategorie.length > 0) {
        const articleKategorien = Array.isArray(article.kategorie) ? article.kategorie : (article.kategorie ? [article.kategorie] : []);
        const hasMatchingKategorie = articleKategorien.some(kat => currentFilters.kategorie.includes(kat));
        if (!hasMatchingKategorie) {
          return false;
        }
      }

      if (currentFilters.schwierigkeit.length > 0) {
        if (!article.schwierigkeit || !currentFilters.schwierigkeit.includes(article.schwierigkeit)) {
          return false;
        }
      }

      const gesamtzeit = article.gesamtzeit || 0;
      if (gesamtzeit < currentFilters.timeMin || gesamtzeit > currentFilters.timeMax) {
        return false;
      }

      return true;
    }

    function updateActiveFilters() {
      if (!activeFiltersContainer) return;

      const activeFilters = [];
      
      currentFilters.kategorie.forEach(kat => {
        activeFilters.push({
          label: `Kategorie: ${kat}`,
          remove: () => {
            currentFilters.kategorie = currentFilters.kategorie.filter(k => k !== kat);
            currentFilters.currentPage = 1;
            applyFilters();
          }
        });
      });

      currentFilters.schwierigkeit.forEach(sch => {
        activeFilters.push({
          label: `Schwierigkeit: ${sch}`,
          remove: () => {
            currentFilters.schwierigkeit = currentFilters.schwierigkeit.filter(s => s !== sch);
            currentFilters.currentPage = 1;
            applyFilters();
          }
        });
      });

      if (currentFilters.timeMin > filterData.minTime || currentFilters.timeMax < 300) {
        activeFilters.push({
          label: `Zeit: ${currentFilters.timeMin}min-${currentFilters.timeMax}min`,
          remove: () => {
            currentFilters.timeMin = filterData.minTime;
            currentFilters.timeMax = 300;
            currentFilters.currentPage = 1;
            applyFilters();
          }
        });
      }

      if (activeFilters.length === 0) {
        activeFiltersContainer.innerHTML = '';
        return;
      }

      let html = '<div class="active-facets h-stack wrap gap-2">';
      activeFilters.forEach(filter => {
        html += `
          <button type="button" class="active-facet" data-filter-remove>
            <span>${filter.label}</span>
            <span class="active-facet__remove">×</span>
          </button>
        `;
      });
      html += '</div>';

      activeFiltersContainer.innerHTML = html;

      activeFiltersContainer.querySelectorAll('[data-filter-remove]').forEach((btn, index) => {
        btn.addEventListener('click', activeFilters[index].remove);
      });
    }

    function hasActiveFilters() {
      return currentFilters.kategorie.length > 0 || 
             currentFilters.schwierigkeit.length > 0 || 
             currentFilters.timeMin > filterData.minTime || 
             currentFilters.timeMax < 300;
    }

    function applyFilters() {
      const articleElements = Array.from(postsContainer.querySelectorAll('[data-article-id]'));
      const visibleArticles = [];
      
      articleElements.forEach(articleElement => {
        if (matchesFilters(articleElement)) {
          visibleArticles.push(articleElement);
        } else {
          articleElement.style.display = 'none';
        }
      });

      const hasFilters = hasActiveFilters();
      
      if (hasFilters) {
        if (paginationContainer) {
          paginationContainer.style.display = 'none';
        }
        
        const totalPages = Math.ceil(visibleArticles.length / articlesPerPage);
        if (currentFilters.currentPage > totalPages && totalPages > 0) {
          currentFilters.currentPage = totalPages;
        }
        
        const startIndex = (currentFilters.currentPage - 1) * articlesPerPage;
        const endIndex = startIndex + articlesPerPage;
        
        visibleArticles.forEach((articleElement, index) => {
          if (index >= startIndex && index < endIndex) {
            articleElement.style.display = '';
          } else {
            articleElement.style.display = 'none';
          }
        });
        
        updatePagination(visibleArticles.length, totalPages);
      } else {
        if (paginationContainer) {
          paginationContainer.style.display = '';
        }
        
        articleElements.forEach(articleElement => {
          articleElement.style.display = '';
        });
        
        removeClientPagination();
      }

      updateActiveFilters();
      updateFilterInputs();
      
      const emptyState = postsContainer.querySelector('.empty-state');
      
      if (visibleArticles.length === 0) {
        if (!emptyState) {
          const emptyStateEl = document.createElement('div');
          emptyStateEl.className = 'empty-state';
          emptyStateEl.innerHTML = `
            <div class="empty-state__icon-wrapper">
              <span class="count-bubble count-bubble--lg">0</span>
            </div>
            <div class="prose">
              <p class="h5">Keine Ergebnisse gefunden</p>
            </div>
          `;
          postsContainer.appendChild(emptyStateEl);
        }
        if (paginationContainer) {
          paginationContainer.style.display = 'none';
        }
        removeClientPagination();
      } else if (emptyState) {
        emptyState.remove();
      }
    }
    
    function updatePagination(totalVisible, totalPages) {
      if (!hasActiveFilters() || totalPages <= 1) {
        removeClientPagination();
        return;
      }
      
      let paginationEl = document.querySelector('[data-blog-client-pagination]');
      
      if (!paginationEl) {
        paginationEl = document.createElement('nav');
        paginationEl.className = 'pagination';
        paginationEl.setAttribute('data-blog-client-pagination', '');
        paginationEl.setAttribute('role', 'navigation');
        paginationEl.setAttribute('aria-label', 'Pagination');
        
        if (paginationContainer) {
          paginationContainer.parentNode.insertBefore(paginationEl, paginationContainer.nextSibling);
        } else {
          postsContainer.parentNode.appendChild(paginationEl);
        }
      }
      
      const prevDisabled = currentFilters.currentPage === 1 ? ' pagination__item--disabled' : '';
      const nextDisabled = currentFilters.currentPage >= totalPages ? ' pagination__item--disabled' : '';
      
      let html = '';
      
      if (currentFilters.currentPage > 1) {
        html += `<a class="pagination__item group" href="#" data-page="${currentFilters.currentPage - 1}" rel="prev" aria-label="Go to page ${currentFilters.currentPage - 1}">
          <span class="animated-arrow animated-arrow--reverse"></span>
        </a>`;
      } else {
        html += `<span class="pagination__item pagination__item--disabled">
          <span class="animated-arrow animated-arrow--reverse"></span>
        </span>`;
      }
      
      html += `<span class="pagination__current">${currentFilters.currentPage}&nbsp;&nbsp;/&nbsp;&nbsp;${totalPages}</span>`;
      
      if (currentFilters.currentPage < totalPages) {
        html += `<a class="pagination__item group" href="#" data-page="${currentFilters.currentPage + 1}" rel="next" aria-label="Go to page ${currentFilters.currentPage + 1}">
          <span class="animated-arrow"></span>
        </a>`;
      } else {
        html += `<span class="pagination__item pagination__item--disabled">
          <span class="animated-arrow"></span>
        </span>`;
      }
      
      paginationEl.innerHTML = html;
      
      paginationEl.querySelectorAll('a[data-page]').forEach(link => {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          const page = parseInt(this.getAttribute('data-page'));
          if (page >= 1 && page <= totalPages) {
            currentFilters.currentPage = page;
            applyFilters();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
      });
    }
    
    function removeClientPagination() {
      const paginationEl = document.querySelector('[data-blog-client-pagination]');
      if (paginationEl) {
        paginationEl.remove();
      }
    }

    function updateFilterInputs() {
      filterForm.querySelectorAll('input[name="filter_kategorie"]').forEach(input => {
        input.checked = currentFilters.kategorie.includes(input.value);
      });

      filterForm.querySelectorAll('input[name="filter_schwierigkeit"]').forEach(input => {
        input.checked = currentFilters.schwierigkeit.includes(input.value);
      });

      const timeMinInputs = document.querySelectorAll('[data-time-min]');
      const timeMaxInputs = document.querySelectorAll('[data-time-max]');
      const timeRangeInputs = document.querySelectorAll('[data-time-range]');

      timeMinInputs.forEach(input => {
        input.value = currentFilters.timeMin;
        input.max = currentFilters.timeMax;
      });
      timeMaxInputs.forEach(input => {
        input.value = currentFilters.timeMax;
        input.max = 300;
      });
      timeRangeInputs.forEach(input => {
        input.value = currentFilters.timeMax;
        input.max = 300;
      });
    }

    function isMobileDrawer() {
      const drawer = document.getElementById('blog-facets-drawer');
      if (!drawer) return false;
      const isOpen = drawer.hasAttribute('open');
      const isMobile = window.matchMedia('(max-width: 699px)').matches;
      return isOpen && isMobile;
    }
    
    const drawer = document.getElementById('blog-facets-drawer');
    let allowDrawerClose = false;
    
    if (drawer) {
      const drawerForm = drawer.querySelector('form[data-blog-filter-form]');
      if (drawerForm) {
        drawerForm.addEventListener('submit', function(e) {
          if (isMobileDrawer() && !allowDrawerClose) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        });
      }
      
      const originalHide = drawer.hide;
      if (originalHide) {
        drawer.hide = function() {
          if (isMobileDrawer() && !allowDrawerClose) {
            return Promise.resolve();
          }
          allowDrawerClose = false;
          return originalHide.call(this);
        };
      }
      
      drawer.addEventListener('dialog:after-hide', function(e) {
        if (isMobileDrawer() && !allowDrawerClose) {
          e.stopPropagation();
          e.preventDefault();
        }
        allowDrawerClose = false;
      }, true);
      
      drawer.addEventListener('click', function(e) {
        const target = e.target;
        const isCheckbox = target.type === 'checkbox';
        const isLabel = target.tagName === 'LABEL';
        const isCheckboxContainer = target.closest('.checkbox-container');
        const isCheckboxRelated = isCheckbox || isLabel || isCheckboxContainer;
        
        if (isMobileDrawer() && isCheckboxRelated) {
          if (isLabel || (isCheckboxContainer && target !== target.closest('input[type="checkbox"]'))) {
            return;
          }
        }
      }, true);
    }

    filterForm.querySelectorAll('input[name="filter_kategorie"]').forEach(input => {
      input.addEventListener('change', function() {
        if (this.checked) {
          if (!currentFilters.kategorie.includes(this.value)) {
            currentFilters.kategorie.push(this.value);
          }
        } else {
          currentFilters.kategorie = currentFilters.kategorie.filter(k => k !== this.value);
        }
        currentFilters.currentPage = 1;
        if (!isMobileDrawer()) {
          applyFilters();
        }
      });
    });

    filterForm.querySelectorAll('input[name="filter_schwierigkeit"]').forEach(input => {
      input.addEventListener('change', function() {
        if (this.checked) {
          if (!currentFilters.schwierigkeit.includes(this.value)) {
            currentFilters.schwierigkeit.push(this.value);
          }
        } else {
          currentFilters.schwierigkeit = currentFilters.schwierigkeit.filter(s => s !== this.value);
        }
        currentFilters.currentPage = 1;
        if (!isMobileDrawer()) {
          applyFilters();
        }
      });
    });

    const actualMaxTime = 300;
    
    timeMinInputs.forEach(input => {
      input.addEventListener('change', function() {
        currentFilters.timeMin = parseInt(this.value) || filterData.minTime;
        if (currentFilters.timeMin > currentFilters.timeMax) {
          currentFilters.timeMin = currentFilters.timeMax;
          this.value = currentFilters.timeMin;
        }
        currentFilters.currentPage = 1;
        if (!isMobileDrawer()) {
          applyFilters();
        }
      });
    });

    timeMaxInputs.forEach(input => {
      input.addEventListener('change', function() {
        let newMax = parseInt(this.value) || actualMaxTime;
        if (newMax > actualMaxTime) {
          newMax = actualMaxTime;
          this.value = newMax;
        }
        if (newMax < currentFilters.timeMin) {
          newMax = currentFilters.timeMin;
          this.value = newMax;
        }
        currentFilters.timeMax = newMax;
        currentFilters.currentPage = 1;
        timeRangeInputs.forEach(rangeInput => {
          rangeInput.value = currentFilters.timeMax;
        });
        timeMinInputs.forEach(minInput => {
          minInput.max = currentFilters.timeMax;
        });
        if (!isMobileDrawer()) {
          applyFilters();
        }
      });
    });

    timeRangeInputs.forEach(input => {
      input.addEventListener('input', function() {
        let newMax = parseInt(this.value);
        if (newMax > actualMaxTime) {
          newMax = actualMaxTime;
          this.value = newMax;
        }
        currentFilters.timeMax = newMax;
        currentFilters.currentPage = 1;
        timeMaxInputs.forEach(maxInput => {
          maxInput.value = currentFilters.timeMax;
        });
        timeMinInputs.forEach(minInput => {
          minInput.max = currentFilters.timeMax;
        });
        if (!isMobileDrawer()) {
          applyFilters();
        }
      });
    });
    
    const applyButtons = document.querySelectorAll('[is="blog-filter-apply-button"]');
    applyButtons.forEach(applyButton => {
      applyButton.addEventListener('click', function() {
        allowDrawerClose = true;
        applyFilters();
        const drawer = document.getElementById('blog-facets-drawer');
        if (drawer && drawer.hide) {
          drawer.hide();
        }
      });
    });

    applyFilters();
    
    function setupCheckboxLabels() {
      const checkboxContainers = document.querySelectorAll('.checkbox-container');
      checkboxContainers.forEach(container => {
        const checkbox = container.querySelector('input[type="checkbox"]');
        const label = container.querySelector('label');
        
        if (checkbox && label) {
          container.style.cursor = 'pointer';
          label.style.cursor = 'pointer';
          label.style.pointerEvents = 'auto';
          label.style.userSelect = 'none';
          label.style.webkitUserSelect = 'none';
          
          if (!checkbox.id) {
            const checkboxId = 'checkbox-' + Math.random().toString(36).substr(2, 9);
            checkbox.id = checkboxId;
          }
          
          const checkboxId = checkbox.id;
          label.setAttribute('for', checkboxId);
          
          const handleLabelClick = function(e) {
            e.stopPropagation();
            if (e.target === label || label.contains(e.target)) {
              checkbox.checked = !checkbox.checked;
              const changeEvent = new Event('change', { bubbles: true });
              checkbox.dispatchEvent(changeEvent);
            }
          };
          
          label.addEventListener('click', handleLabelClick);
          label.addEventListener('touchend', function(e) {
            e.preventDefault();
            handleLabelClick(e);
          });
          
          container.addEventListener('click', function(e) {
            if (e.target === container && e.target !== checkbox) {
              checkbox.checked = !checkbox.checked;
              const changeEvent = new Event('change', { bubbles: true });
              checkbox.dispatchEvent(changeEvent);
            }
          });
        }
      });
    }
    
    setupCheckboxLabels();
    
    if (drawer) {
      const setupWhenOpen = function() {
        setTimeout(function() {
          setupCheckboxLabels();
        }, 100);
      };
      
      drawer.addEventListener('dialog:after-show', setupWhenOpen);
      drawer.addEventListener('open', setupWhenOpen);
      
      const observer = new MutationObserver(function(mutations) {
        let shouldSetup = false;
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length) {
            shouldSetup = true;
          }
        });
        if (shouldSetup) {
          setTimeout(setupCheckboxLabels, 50);
        }
      });
      
      observer.observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogFilters);
  } else {
    initBlogFilters();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(initBlogFilters, 100);
  });
})();


